import React, { useState } from 'react';
import './ContactForm.css';

const ContactForm = () => {
  const [email, setEmail] = useState('');
  const [message, setMessage] = useState('');
  const [status, setStatus] = useState('idle');
  const [feedback, setFeedback] = useState('');
  const isFormValid = email.trim().length > 0 && message.trim().length > 0;

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!isFormValid || status === 'sending') return;

    setStatus('sending');
    setFeedback('');

    try {
      const response = await fetch('https://email-server-vmj6t6xd3q-uc.a.run.app/send-email', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ email: email.trim(), message: message.trim() }),
      });

      if (!response.ok) {
        throw new Error(`Contact request failed with status ${response.status}`);
      }

      setEmail('');
      setMessage('');
      setStatus('success');
      setFeedback('Thanks! Your message has been sent.');
    } catch (error) {
      console.error('Unable to send contact message:', error);
      setStatus('error');
      setFeedback('Sorry, your message could not be sent. Please try again or email contact@verdantevolution.com.');
    }
  };

  return (
    <div className="contact-form-container">
      <form onSubmit={handleSubmit}>
        <h2>Contact Us</h2>
        <div className="input-group">
          <label htmlFor="email">Email</label>
          <input
            type="email"
            id="email"
            value={email}
            onChange={(e) => {
              setEmail(e.target.value);
              if (status !== 'idle') {
                setStatus('idle');
                setFeedback('');
              }
            }}
            autoComplete="email"
            required
          />
        </div>
        <div className="input-group">
          <label htmlFor="message">Message</label>
          <textarea
            id="message"
            value={message}
            onChange={(e) => {
              setMessage(e.target.value);
              if (status !== 'idle') {
                setStatus('idle');
                setFeedback('');
              }
            }}
            required
            style={{resize: 'none'}}
          />
        </div>
        <button type="submit" disabled={!isFormValid || status === 'sending'}>
          {status === 'sending' ? 'Sending…' : 'Send Message'}
        </button>
        {feedback && (
          <p className={`form-feedback ${status}`} role={status === 'error' ? 'alert' : 'status'}>
            {feedback}
          </p>
        )}
      </form>
    </div>
  );
};

export default ContactForm;
